
const calculateMaxTurn = (turns, category) => {
    const turnValues = turns.map(t => t[category]);
    return Math.max(...turnValues);
};

export default calculateMaxTurn;